var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    viewBox: "20 20 75 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    strokeWidth: 4,
    fill: "none",
    d: " M56.500000,97.500000  C68.609734,87.228577 77.973900,75.208221 80.474792,58.996113  C82.478821,46.004940 77.369080,36.865955 65.504486,31.490103  C54.576073,26.538433 43.361614,30.463724 36.572418,39.057213  C29.991058,47.387630 29.978640,56.859524 33.510151,66.496277  C38.111477,79.052322 45.716469,89.488235 56.000000,98.000000  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    strokeWidth: 4,
    fill: "none",
    d: " M68.000000,60.500000  C70.002533,51.662106 68.620377,47.055088 63.006042,43.490479  C58.741806,40.783062 54.307976,40.579601 50.031559,43.054535  C45.367546,45.753784 42.628654,50.148514 43.142700,55.486256  C43.646935,60.722095 46.676159,64.637611 51.980377,66.554298  C54.923077,67.617645 57.666668,67.883163 60.500000,66.500000  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location-pin.7e57a46d.svg";
export { ForwardRef as ReactComponent };